import PropTypes from "prop-types";
import { Box } from "@mui/material";

import InputWithSlider from "./components/ResourceInputSlider";

const FIELD_STACK = {
  display: "flex",
  flexDirection: "column",
  gap: 0.5,
};

const CPUResourceForm = ({
  effectiveLimits,
  value,
  errors,
  onChange,
  disabled,
  runtimeField,
}) => {
  const clampSliderMax = (limit) => Math.max(1, limit ?? 1);

  const handleFieldChange = (field) => (e) => {
    onChange({ [field]: e.target.value });
  };

  return (
    <Box sx={FIELD_STACK}>
      {runtimeField}
      <InputWithSlider
        id="node-count"
        label="Workers"
        description="Number of workers in the experiment."
        value={value.nodeCount}
        onChange={handleFieldChange("nodeCount")}
        helperText={errors.nodeCount || ""}
        error={!!errors.nodeCount}
        disabled={disabled}
        minInput={1}
        maxInput={clampSliderMax(effectiveLimits.max_workers)}
      />

      <InputWithSlider
        id="cpu-cores"
        label="vCPUs per worker"
        description="The number of vCPUs per worker."
        value={value.cpuCores}
        onChange={handleFieldChange("cpuCores")}
        helperText={errors.cpuCores || ""}
        error={!!errors.cpuCores}
        disabled={disabled}
        minInput={1}
        maxInput={clampSliderMax(effectiveLimits.max_cpus)}
      />

      <InputWithSlider
        id="memory-size"
        label="Memory per worker (Gi)"
        description="The memory size per worker."
        value={value.memory}
        onChange={handleFieldChange("memory")}
        helperText={errors.memory || ""}
        error={!!errors.memory}
        disabled={disabled}
        minInput={1}
        maxInput={clampSliderMax(effectiveLimits.max_mem_gi)}
      />
    </Box>
  );
};

CPUResourceForm.propTypes = {
  effectiveLimits: PropTypes.shape({
    max_workers: PropTypes.number,
    max_cpus: PropTypes.number,
    max_mem_gi: PropTypes.number,
  }).isRequired,
  value: PropTypes.shape({
    cpuCores: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    memory: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    nodeCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
  }).isRequired,
  errors: PropTypes.shape({
    cpuCores: PropTypes.string,
    memory: PropTypes.string,
    nodeCount: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  // Optional leading field, usually the page's "Runtime" slider.
  runtimeField: PropTypes.node,
};

export default CPUResourceForm;
